import type { ComponentPropsWithRef } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'
import { fieldClassName } from './field-class'

export const Input = ({
  register,
  ...rest
}: ComponentPropsWithRef<'input'> & { register: UseFormRegisterReturn }) => {
  return <input {...rest} className={fieldClassName} {...register} />
}
